import styled from "styled-components";
import { ReactComponent as RightBracket } from "../Images/right_bracket.svg";

const MembersInfoBar = ({
  capacityCount,
  possibleCount,
  waitingCount,
  onOpenMemberApprove,
}) => {
  return (
    <InfoBar>
      <InfoCard>
        <InfoCardTitle>구성원 용량</InfoCardTitle>
        <InfoCardValue $color="#1167ed">
          {capacityCount?.toLocaleString()}명
        </InfoCardValue>
      </InfoCard>
      <InfoCard>
        <InfoCardTitle>승인 가능 구성원</InfoCardTitle>
        <InfoCardValue>{possibleCount?.toLocaleString()}명</InfoCardValue>
      </InfoCard>
      <InfoCard>
        <WaitingInfoTrigger onClick={onOpenMemberApprove}>
          <WaitingInfoTitle>승인 대기 구성원</WaitingInfoTitle>
          <WaitingInfoIcon stroke="#6d6d6d" width="24px" height="24px" />
        </WaitingInfoTrigger>
        <InfoCardValue>{waitingCount?.toLocaleString()}명</InfoCardValue>
      </InfoCard>
    </InfoBar>
  );
};

const InfoBar = styled.div`
  width: auto;
  height: 140px;
  display: flex;
  margin-top: 30px;
  margin-left: 30px;
`;

const InfoCard = styled.div`
  width: 366px;
  height: 140px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0 0 20px 0 #f2f2f2;
  margin-right: 30px;
`;

const InfoCardTitle = styled.p`
  font-family: "notoSans-medium";
  font-size: 20px;
  color: #000000;
  margin: 23px 0 0 30px;
`;

const InfoCardValue = styled.p`
  font-family: "notoSans-bold";
  font-size: 24px;
  color: ${(props) => props.$color ?? "#000000"};
  margin: 30px 0 0 30px;
`;

const WaitingInfoTrigger = styled.div`
  display: flex;
  align-items: center;
  margin: 23px 0 0 30px;
  cursor: pointer;
`;

const WaitingInfoTitle = styled(InfoCardTitle)`
  margin: 0;
`;

const WaitingInfoIcon = styled(RightBracket)`
  vertical-align: middle;
  margin-left: 4px;
`;

export default MembersInfoBar;
